import React, { useEffect, useState, useContext, use } from "react";
import DoctorChatBox from "../chat/chatBox";
import Navbar from "../header";
import Footer from "../footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import api, { API_URL, formatDate, AuthContext, showAlert, formatTime } from "../util/api";
import PremiumLoader from "../loading";
import { u } from "framer-motion/client";



export default function AppointmentInteractionPage() {

    const { id } = useParams();
    const router = useNavigate();
    const [receiverid, setReceiverID] = useState(0);
    const [loading, setloading] = useState(true);
    const [role, setRole] = useState(" ");
    const [receiver, setReceiver] = useState([]);
    const [appointment, setAppointment] = useState([]);
    const { User } = useContext(AuthContext);

    const [messages, setMessages] = useState([
        { from: "lawyer", text: "Hello, good day. How are you feeling today?" },
        { from: "patient", text: "Good day Lawyer." }
    ]);

    const [newMessage, setNewMessage] = useState("");
    const [typing, setTyping] = useState(false);




    const [selectedHistory, setSelectedHistory] = useState(null);
    const [addHistoryPopup, setAddHistoryPopup] = useState(false);
    const [editingHistoryIndex, setEditingHistoryIndex] = useState(null);
    const [newHistoryTitle, setNewHistoryTitle] = useState("");
    const [newHistoryDetails, setNewHistoryDetails] = useState("");
    const [attachments, setAttachments] = useState([]);
    const [patientRequest, setPatientRequest] = useState("");
    const [attachment, setAttachment] = useState("");
    const [consultationId, setConsultationId] = useState(0);
    const [consultation, setConsultation] = useState(null);

    const [showFullRequest, setShowFullRequest] = useState(false);
    const [client, setClient] = useState(null);


    const sendMessage = () => {
        if (!newMessage.trim()) return;
        setMessages([...messages, { from: "patient", text: newMessage }]);
        setNewMessage("");

        setTyping(true);
        setTimeout(() => setTyping(false), 2000);
    };




    const checkAppointment = async () => {
        try {
            const response = await api.get(`${API_URL}/check-appointment/${id}`);

            let output = response.data;

            //cheeck if appointment is paid for ...
           

            if (response.data.status !== 'success') {
                router("/");

            } else {
                if(output.appointment.status === "pending"){
                    //check if the user is the patient  or not 
                    if(User.id  === output.appointment.patient_id ){ 

                    router(`/payment_options/${output.appointment.id}`);

                    }else{

                        router("/");
                    }

                }

                setReceiverID(output.receiver_id);
                setRole(output.role);
                setReceiver(output.receiver);
                setAppointment(output.appointment);
                setPatientRequest(output.appointment.report);
                setAttachment(output.appointment.attachment);

                setConsultationId(output.consultation_id);
                setConsultation(output.consultation);
                setClient(output.client);
                setloading(false);

            }

        } catch (error) {

            //alert(error);
            /* console.error("Error fetching doctors:", error); */

        }

    }


    const [showReportPopup, setShowReportPopup] = useState(false);
    const [reportReason, setReportReason] = useState("");
    const [reportComment, setReportComment] = useState("");
    const [reportLoading, setReportLoading] = useState(false);


    const [showCancelPopup, setShowCancelPopup] = useState(false);

    const [cancelComment, setCancelComment] = useState("");
    const [cancelLoading, setCancelLoading] = useState(false);


    const reportReasons = [
        "Lawyer was unprofessional",
        "Incorrect legal advice",
        "Poor communication",
        "Lawyer did not respond properly",
        "Late consultation",
        "Missed appointment",
        "Unclear billing or charges",
        "Case handling issue",
        "Inappropriate behaviour",
        "Other"
    ];
    const submitReport = async () => {
        if (!reportReason) {
            showAlert('error', 'error', "Please select a reason for reporting.");
            return;
        }
        try {
            setReportLoading(true);
            const payload = {
                consultation_id: consultationId,
                appointment_id: appointment.id,
                reason: reportReason,
                comment: reportComment
            };

            const response = await api.post(`${API_URL}/consultation/report`, payload);

            if (response.data.status === "success") {
                showAlert("success", "success", "Report submitted successfully.");
                setShowReportPopup(false);
                setReportReason("");
                setReportComment("");
            } else {
                showAlert("error", "error", response.data.message || "Unable to submit report.");
            }

        } catch (error) {
            showAlert("error", "error", "An error occurred while submitting the report.");
        } finally {
            setReportLoading(false);
        }
    };



    const submitCancel = async () => {
        if (!cancelComment) {
            showAlert('error', 'error', "Please type the reason for canceling.");
            return;
        }

        try {
            setCancelLoading(true);

            const payload = {

                consultation_id: consultationId,
                appointment_id: appointment.id,
                comment: cancelComment
            };

            const response = await api.post(`${API_URL}/consultation/cancel`, payload);

            if (response.data.status === "success") {
                showAlert("success", "success", "Cancel successfully.");
                setShowCancelPopup(false);

                setCancelComment("");

                router("/lawyer-dashboard");
            } else {
                showAlert('error', 'error', response.data.message || "Unable to submit report.");
            }

        } catch (error) {
            showAlert('error', 'error', "An error occurred while submitting the report.");
        } finally {
            setCancelLoading(false);
        }
    };



    useEffect(() => {

        checkAppointment();
        //check if  appointment is already paid for or  exist  .  

    }, []);



    const [showInvoicePopup, setShowInvoicePopup] = useState(false);
    const [invoiceReason, setInvoiceReason] = useState("");
    const [invoiceAmount, setInvoiceAmount] = useState("");
    const [invoiceUrgency, setInvoiceUrgency] = useState("Normal");
    const [invoiceFiles, setInvoiceFiles] = useState([]);
    const [invoiceLoading, setInvoiceLoading] = useState(false);

    const[startTime , setStartTime] =   useState();
    const[endTime  ,  setendTime]  =  useState()  ;


    const handleInvoiceFiles = (e) => {
        setInvoiceFiles(Array.from(e.target.files || []));
    };

    const submitInvoiceRequest = async () => {
        if (!invoiceReason.trim()) {
            showAlert("error", "error", "Please provide a reason for the invoice request.");
            return;
        }

        try {
            setInvoiceLoading(true);
            const form = new FormData();
            form.append("consultation_id", consultationId);
            form.append("appointment_id", appointment.id);
            form.append("reason", invoiceReason);
            form.append("start_time"  , startTime);
            form.append("end_time"   ,  endTime);
            if (invoiceAmount) form.append("estimated_amount", invoiceAmount);
            form.append("urgency", invoiceUrgency);

            invoiceFiles.forEach((file, idx) => form.append(`attachments[${idx}]`, file));

            const response = await api.post(`${API_URL}/invoices/request`, form, {
                headers: { "Content-Type": "multipart/form-data" }
            });

            if (response.data?.status === "success") {
                showAlert("success", "success", response.data.message || "Invoice request submitted.");
                setShowInvoicePopup(false);
                setInvoiceReason("");
                setInvoiceAmount("");
                setInvoiceFiles([]);
                // optional redirect:
                // router("/client-dashboard");
            } else {
                showAlert("error", "error", response.data?.message || "Unable to submit invoice request.");
            }
        } catch (err) {
            showAlert("error", "error", "An error occurred while submitting the invoice request.");
        } finally {
            setInvoiceLoading(false);
        }
    };


    return (
        <>
            <Navbar menuColor="red" />
            {!loading ?

                <section >


                    <div style={styles.wrapper}>
                        <style>{`
                    @keyframes fadeUp { 0% {opacity:0; transform:translateY(40px);} 100% {opacity:1; transform:translateY(0);} }
                    @keyframes pop { 0% {transform:scale(0.9); opacity:0;} 100% {transform:scale(1); opacity:1;} }
                    @keyframes typingBlink { 0% { opacity: 0.2; } 100% { opacity: 1; } }
                    @media (max-width: 768px) {
                        .layout { flex-direction: column !important; width: 95% !important; }
                        .left, .right { width: 100% !important; }
                    }
                    `}</style>

                        <div className="layout" style={styles.layout}>
                            {/* LEFT */}
                            <div className="left" style={styles.left}>
                                <div align="left">
                                    <button
                                        onClick={appointment.patient_id === User.id ? () => router("/client-dashboard") : () => router("/lawyer-dashboard")}
                                        style={{
                                            background: "transparent",
                                            border: "none",
                                            color: "#007bff",
                                            cursor: "pointer",
                                            fontSize: 16,
                                            padding: 0,
                                        }}
                                        aria-label="Go back"
                                    >
                                        ← Back
                                    </button>
                                </div>

                               

                                <h2 style={styles.heading}>Appointment Overview</h2>

                                {    appointment.parent_appointment_id === null &&

                                 <>
                                <p>
                                    Created On  : {formatDate(appointment.updated_at)}
                                    <br />
                                    Booked :  {appointment.day}
                                    <br />
                                    Start Time  :   {formatTime(appointment.starttime)}
                                    <br />

                                    End Time  :  {formatTime(appointment.endtime)}

                                </p>

                                </>

                                }



                                 {    appointment.parent_appointment_id !== null &&

                                 <>
                                <p>
                                    Created On  : {formatDate(appointment.updated_at)}
                                    <br />
                                   
                                    Start Time  :    {formatDate(appointment.starttime)}{" "}
                                    {formatTime(appointment.starttime)}
                                    <br />

                                    End Time  :  {formatDate(appointment.endtime)}{" "}
                                    {formatTime(appointment.endtime)}

                                    <br/>
                                    <Link  className="btn btn-sm btn-info" to={`/appointments/${appointment.parent_appointment_id}`}> Related Appointment </Link>

                                </p>

                                </>

                                }





                                <div style={styles.frostCard}>
                                    <h3 style={{ ...styles.cardTitle, textTransform: "capitalize" }}>{role}</h3>
                                    <div style={styles.userRow}>

                                        {/* check the  user role */}
                                        {role === "Lawyer" ? (
                                            <img alt="" src={receiver.profilePicture || ""} style={styles.avatar} />
                                        ) : (
                                            <>
                                                <img alt="" src={client.profilePicture || ""} style={styles.avatar} />

                                            </>
                                        )}

                                        <div>
                                            <p><strong>{receiver.name}</strong></p>
                                            {/*  <p style={styles.subText}>Cardiologist</p> */}
                                        </div>
                                    </div>
                                </div>




                                {/* Patient Request / Symptoms */}
                                <div style={styles.frostCard}>
                                    {   appointment.parent_appointment_id === null &&
                                    <h3 style={styles.cardTitle}>Client Request </h3>

                                    }


                                    {   appointment.parent_appointment_id !== null &&
                                    <h3 style={styles.cardTitle}>Reason </h3>

                                    }





                                    {patientRequest !== null &&
                                        <p style={{ fontSize: "14px", lineHeight: "1.5", color: "#333" }}>
                                            {showFullRequest ? patientRequest : (patientRequest.length > 120 ? patientRequest.slice(0, 120) + "..." : patientRequest)}
                                        </p>
                                    }

                               
                                    {patientRequest !== null && <>

                                        {patientRequest.length > 120 && (
                                            <button
                                                style={styles.readMoreBtn}
                                                onClick={() => setShowFullRequest(!showFullRequest)}
                                            >
                                                {showFullRequest ? "Read less" : "Read more"}
                                            </button>
                                        )}

                                    </>

                                    

                                    }

                                     <br/>

                                         {attachment !== "" && (

                                        <>
                                            <a href={attachment} target="_blank" rel="noreferrer">View Attachment</a>
                                            <br />
                                        </>
                                    )}

                                    <br/>



                                             <Link   to="/appointment-terms-and-conditions" className="btn btn-sm btn-info">Terms of Service</Link>

                                </div>

                                {/* Medical History */}

                            </div>

                            {/* RIGHT — CHAT */}
                            <div className="right" style={styles.right}>
                                <h2 style={styles.heading}>Live Consultation Chat</h2>


                                <DoctorChatBox id={receiverid} appointment={appointment} picture={receiver.profilePicture} />

                                <div>
                                    <br />
                                    {User.id !== appointment.patient_id &&
                                        <>
                                            {consultationId !== 0 &&

                                                <>
                                                    {consultation.status === "REJECTED" &&

                                                        <p style={{ color: "red", fontWeight: "bolder", backgroundColor: "lightyellow" }}
                                                        >
                                                            {/* info the doctor that the consultation has being rejected that the consultation needs to be updated */}
                                                            The client has rejected your conclusion. Please check the chatbox for details and
                                                            update the consultation conclusion accordingly.
                                                        </p>

                                                    }

                                                    {consultation.status === "PENDING" &&

                                                        <>

                                                            <p style={{ color: "orange", fontWeight: "bolder", backgroundColor: "lightyellow" }} >

                                                                The consultation is concluded and pending client acceptance.  The consultation  will be
                                                                automatically accepted after 7 days if no action is taken.

                                                            </p>

                                                        </>

                                                    }


                                                    {consultation.status === "COMPLETED" &&

                                                        <>

                                                            <p style={{ color: "orange", fontWeight: "bolder", backgroundColor: "lightyellow" }} >
                                                                The consultation has been completed and accepted by the client.

                                                            </p>

                                                            {/* show the rate and the comment of the client  here  */}
                                                            <div>


                                                                <div>
                                                                    <strong>Client Rating:</strong>
                                                                    <div
                                                                        aria-label={`Rating: ${consultation?.patient_rating ?? 0} out of 5`}
                                                                        style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 6 }}
                                                                    >
                                                                        {Array.from({ length: 5 }).map((_, i) => {
                                                                            const filled = i < Math.round(consultation?.patient_rating ?? 0);
                                                                            return (
                                                                                <span
                                                                                    key={i}
                                                                                    style={{
                                                                                        color: filled ? "#f5b301" : "#ddd",
                                                                                        fontSize: 20,
                                                                                        lineHeight: 1,
                                                                                    }}
                                                                                >
                                                                                    {filled ? "★" : "☆"}
                                                                                </span>
                                                                            );
                                                                        })}
                                                                        <span style={{ marginLeft: 8, color: "#333", fontSize: 14 }}>
                                                                            {consultation?.patient_rating != null ? Number(consultation.patient_rating).toFixed(1) : "No rating"}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <strong>Client Comment:</strong> <br /> {consultation.patient_comment}
                                                            </div>

                                                        </>

                                                    }







                                                </>

                                            }


                                           


                                            {(appointment.status !== "completed" && appointment.status !== "cancelled") &&
                                                <>

                                                    <Link style={{ marginBottom: "10px" }} className="btn btn-sm btn-primary"
                                                        to={`/complete_consultation/${id}`} >  {consultationId === 0 ? <> Complete Consultation  </> :
                                                            <> Update Consultation conclusion </>} </Link>
                                                    &nbsp; &nbsp;





                                                </>

                                            }


                                             <button style={{ marginBottom: "10px" }} className="btn btn-sm btn-primary"
                                                onClick={() => setShowInvoicePopup(true) } >  Raise Invoice For Further Action </button>
                                            &nbsp; &nbsp;




                                        </>

                                    }


                                    {consultationId !== 0 &&

                                        <>

                                            {(consultation.status === "PENDING" && User.id === appointment.patient_id) && <>
                                                <p>
                                                    Your consultation has been concluded. You can view the legal advice, recommendations, and case summary
                                                    by clicking the button below to accept it or request further clarification from the lawyer.
                                                </p>

                                            </>}

                                            <Link style={{ marginBottom: "10px" }} className="btn btn-sm btn-primary"
                                                to={`/consultation/${consultationId}`} >Legal Consultation Summary  </Link>


                                            {(User.id === appointment.patient_id && appointment.status === "completed") &&

                                                <>
                                                    &nbsp;&nbsp;

                                                    <Link style={{ marginBottom: "10px" }} className="btn btn-sm btn-primary"
                                                        to={`/lawyer-profile/${appointment.doctor_id}`} > Book Appointment  </Link>


                                                </>

                                            }





                                        </>

                                    }


                                    


                                    {appointment.status === "booked" &&
                                        <>

                                            {User.id === appointment.patient_id &&
                                                <>
                                                    &nbsp;  &nbsp;
                                                    <button
                                                        className="btn btn-sm btn-danger"
                                                        onClick={() => setShowReportPopup(true)}
                                                    >
                                                        Report Consultation
                                                    </button>


                                                </>

                                            }

                                            {User.id !== appointment.patient_id &&


                                                <>


                                                    &nbsp;
                                                    <button onClick={() => setShowCancelPopup(true)}
                                                        style={{ marginBottom: "10px", backgroundColor: "red", color: "white" }} className="btn btn-sm btn-danger">Cancel</button>


                                                </>

                                            }


                                        </>

                                    }

                                    {appointment.status === "cancelled" &&

                                        <>
                                            <p style={{ color: "red", backgroundColor: "yellow" }}>

                                                {appointment.cancel_comment}
                                            </p>
                                        </>
                                    }



                                </div>

                            </div>


                        </div>

                        {/* VIEW HISTORY POPUP */}
                        {selectedHistory && (
                            <div style={styles.popupOverlay}>
                                <div style={styles.popupCard}>
                                    <h3>{selectedHistory.title}</h3>
                                    <div style={{ fontSize: "15px", lineHeight: "1.5" }}>{selectedHistory.details}</div>

                                    {selectedHistory.attachments.length > 0 && (
                                        <div style={{ marginTop: "10px" }}>
                                            <strong>Attachments:</strong>
                                            {selectedHistory.attachments.map((file, i) => (
                                                <div key={i} style={{ color: "#0077b6", fontSize: "14px" }}>{file.name}</div>
                                            ))}
                                        </div>
                                    )}

                                    <button style={styles.closePopupBtn} onClick={() => setSelectedHistory(null)}>Close</button>
                                </div>
                            </div>
                        )}




                        {/* report popup area  */}
                        {showReportPopup && (
                            <div style={styles.popupOverlay}>
                                <div style={styles.popupCard}>
                                    <h3 style={{ color: "#b00000" }}>Report Consultation</h3>

                                    <label style={{ fontSize: 14, fontWeight: "600" }}>
                                        Select Reason
                                    </label>
                                    <select
                                        style={styles.popupInput}
                                        value={reportReason}
                                        onChange={(e) => setReportReason(e.target.value)}
                                    >
                                        <option value="">-- Select reason --</option>
                                        {reportReasons.map((reason, index) => (
                                            <option key={index} value={reason}>
                                                {reason}
                                            </option>
                                        ))}
                                    </select>

                                    <label style={{ fontSize: 14, fontWeight: "600" }}>
                                        Additional Comment (optional)
                                    </label>
                                    <textarea
                                        style={styles.popupTextarea}
                                        placeholder="Explain your issue in detail..."
                                        value={reportComment}
                                        onChange={(e) => setReportComment(e.target.value)}
                                    />

                                    <button
                                        style={{
                                            ...styles.saveBtn,
                                            background: "#b00000",
                                            opacity: reportLoading ? 0.6 : 1
                                        }}
                                        onClick={submitReport}
                                        disabled={reportLoading}
                                    >
                                        {reportLoading ? "Submitting..." : "Submit Report"}
                                    </button>

                                    <button
                                        style={styles.closePopupBtn}
                                        onClick={() => setShowReportPopup(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        )}



                        {/* cancel popup area  */}
                        {showCancelPopup && (
                            <div style={styles.popupOverlay}>
                                <div style={styles.popupCard}>
                                    <h3 style={{ color: "#b00000" }}>Cancel Consultation</h3>



                                    <label style={{ fontSize: 14, fontWeight: "600" }}>
                                        Reason
                                    </label>
                                    <textarea
                                        style={styles.popupTextarea}
                                        placeholder="Explain your issue in detail..."
                                        value={cancelComment}
                                        onChange={(e) => setCancelComment(e.target.value)}
                                    />

                                    <button
                                        style={{
                                            ...styles.saveBtn,
                                            background: "#b00000",
                                            opacity: cancelLoading ? 0.6 : 1
                                        }}
                                        onClick={submitCancel}
                                        disabled={cancelLoading}
                                    >
                                        {cancelLoading ? "Submitting..." : "Submit "}
                                    </button>

                                    <button
                                        style={styles.closePopupBtn}
                                        onClick={() => setShowCancelPopup(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        )}





                        {showInvoicePopup && (
                            <div style={styles.popupOverlay}>
                                <div style={styles.popupCard}>
                                    <h3 style={{ color: "#03fa41ff" }}>Request Invoice for Further Legal Action</h3>

                                    <label style={{ fontSize: 14, fontWeight: "600" }}>Reason</label>
                                    <textarea
                                        style={styles.popupTextarea}
                                        placeholder="Explain your issue in detail..."
                                        value={invoiceReason}
                                        onChange={(e) => setInvoiceReason(e.target.value)}
                                        aria-label="Invoice reason"
                                    />

                                    <label style={{ fontSize: 14, fontWeight: "600" }}>Estimated amount </label>
                                    <input
                                        type="number"
                                        style={styles.popupInput}
                                        placeholder="e.g. 1500.00"
                                        value={invoiceAmount}
                                        onChange={(e) => setInvoiceAmount(e.target.value)}
                                    />
{/* 
                                   <label style={{ fontSize: 14, fontWeight: "600" }}>Urgency</label>
                                    <select style={styles.popupInput} value={invoiceUrgency} onChange={(e) => setInvoiceUrgency(e.target.value)}>
                                        <option>Normal</option>
                                        <option>Urgent</option>
                                    </select>  */}

                                    <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 8 }}>
                                        <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
                                            <label style={{ fontSize: 14, fontWeight: 600 }}>Start Time</label>
                                            <input
                                                type="datetime-local"

                                                 value={startTime}
                                                onChange={(e)=>{ setStartTime(e.target.value)}}
                                                
                                              /*   value={appointment?.starttime ? formatTime(appointment.starttime) : ""} */
                                                aria-label="Start time"
                                                style={{
                                                    ...styles.popupInput,
                                                    background: "#f7fbff",
                                                    border: "1px solid #d9e9f7",
                                                    fontWeight: 600,
                                                    color: "#003f63"
                                                }}
                                            />
                                        </div>

                                        <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
                                            <label style={{ fontSize: 14, fontWeight: 600 }}>End Time</label>
                                            <input
                                                type="datetime-local"

                                                value={endTime}
                                                onChange={(e)=>{ setendTime(e.target.value)}}
                                               
                                               /*  value={appointment?.endtime ? formatTime(appointment.endtime) : ""} */
                                                aria-label="End time"
                                                style={{
                                                    ...styles.popupInput,
                                                    background: "#f7fbff",
                                                    border: "1px solid #d9e9f7",
                                                    fontWeight: 600,
                                                    color: "#003f63"
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* <label style={{ fontSize: 14, fontWeight: "600" }}>Attachments (optional)</label>
                                    <input type="file" multiple onChange={handleInvoiceFiles} />
                                     
                                   */}

                                  <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 8 }}>
                                        <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
                                    <button
                                        style={{ ...styles.saveBtn, background: "#00b000ff", opacity: invoiceLoading ? 0.6 : 1 }}
                                        onClick={submitInvoiceRequest}
                                        disabled={invoiceLoading}
                                    >
                                        {invoiceLoading ? "Submitting..." : "Submit"}
                                    </button>
                                    </div>

                                       <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>



                                    <button style={styles.closePopupBtn} onClick={() => setShowInvoicePopup(false)}>Cancel</button>

                                    </div>

                                    </div>
                                </div>
                            </div>
                        )}




                    </div>
                </section>

                :

                <PremiumLoader />


            }

            <Footer />
        </>
    );
}

/* INLINE STYLES */
const styles = {
    wrapper: { width: "100%", minHeight: "100vh", background: "linear-gradient(135deg,#dfefff,#ffffff)", padding: "40px 0", display: "flex", justifyContent: "center" },
    layout: { width: "85%", display: "flex", gap: "30px", animation: "fadeUp 0.8s ease" },
    left: { width: "33%", display: "flex", flexDirection: "column", gap: "20px" },
    right: { width: "67%", display: "flex", flexDirection: "column" },
    heading: { fontSize: "26px", fontWeight: "700", color: "#004d73" },
    frostCard: { padding: "20px", borderRadius: "18px", background: "rgba(255,255,255,0.55)", backdropFilter: "blur(20px)", boxShadow: "0 6px 20px rgba(0,0,0,0.1)", animation: "pop 0.4s ease" },
    cardTitle: { fontSize: "18px", fontWeight: "600", marginBottom: "12px", color: "#006699", display: "flex", justifyContent: "space-between" },
    toggleBtn: { fontSize: "13px", cursor: "pointer", color: "#005f8a" },
    readMoreBtn: { background: "none", border: "none", color: "#0077b6", cursor: "pointer", fontSize: "13px", padding: "0", marginTop: "5px" },
    userRow: { display: "flex", alignItems: "center", gap: "12px" },
    avatar: { width: "55px", height: "55px", borderRadius: "50%" },
    subText: { fontSize: "13px", color: "#777" },
    historyBox: { marginTop: "10px", display: "flex", flexDirection: "column", gap: "8px" },
    historyItem: { padding: "10px", background: "#eef8ff", borderRadius: "10px", fontSize: "14px", display: "flex", justifyContent: "space-between", alignItems: "center" },
    historyButtons: { display: "flex", gap: "6px" },
    editBtn: { padding: "6px 10px", background: "#0077b6", color: "white", border: "none", borderRadius: "6px", cursor: "pointer", fontSize: "12px" },
    deleteBtn: { padding: "6px 10px", background: "#b00000", color: "white", border: "none", borderRadius: "6px", cursor: "pointer", fontSize: "12px" },
    addHistoryBtn: { marginTop: "12px", padding: "10px", background: "#0077b6", border: "none", color: "white", borderRadius: "10px", cursor: "pointer", fontSize: "14px" },
    videoBtn: { width: "100%", marginTop: "12px", padding: "12px", borderRadius: "12px", background: "#0077b6", color: "white", border: "none", cursor: "pointer", fontSize: "15px" },
    chatArea: { flex: 1, background: "white", borderRadius: "20px", padding: "20px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "14px", boxShadow: "0 6px 20px rgba(0,0,0,0.1)" },
    msgBubble: { padding: "12px 16px", borderRadius: "16px", maxWidth: "65%", animation: "fadeUp 0.4s ease", fontSize: "14.5px", lineHeight: "1.4" },
    doctorBubble: { background: "#e6f7ff", alignSelf: "flex-start" },
    patientBubble: { background: "#d4ffe0", alignSelf: "flex-end" },
    typingBubble: { background: "#e6f7ff", alignSelf: "flex-start", padding: "10px 15px", borderRadius: "15px", display: "flex", gap: "4px", width: "50px" },
    typingDot: { animation: "typingBlink 0.7s infinite alternate" },
    inputRow: { display: "flex", gap: "12px", marginTop: "15px" },
    input: { flex: 1, padding: "14px", borderRadius: "12px", border: "1px solid #ccc", fontSize: "15px" },
    sendBtn: { padding: "14px 20px", borderRadius: "12px", background: "#0077b6", border: "none", color: "white", cursor: "pointer" },
    floatingButton: { position: "fixed", bottom: "25px", right: "25px", width: "50px", height: "50px", borderRadius: "50%", background: "#0077b6", color: "white", border: "none", fontSize: "24px", cursor: "pointer", boxShadow: "0 6px 18px rgba(0,0,0,0.2)" },
    popupOverlay: { position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.45)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 999 },
    popupCard: { background: "white", width: "500px", padding: "25px", borderRadius: "16px", boxShadow: "0 10px 35px rgba(0,0,0,0.2)", animation: "pop 0.3s ease", display: "flex", flexDirection: "column", gap: "12px" },
    popupInput: { padding: "12px", borderRadius: "10px", border: "1px solid #ccc", fontSize: "14px" },
    popupTextarea: { padding: "12px", borderRadius: "10px", border: "1px solid #ccc", fontSize: "14px", minHeight: "120px", resize: "vertical" },
    saveBtn: { padding: "12px", borderRadius: "12px", background: "#008000", color: "white", fontSize: "15px", border: "none", cursor: "pointer" },
    closePopupBtn: { padding: "10px", borderRadius: "10px", background: "#b00000", color: "white", fontSize: "14px", border: "none", cursor: "pointer" },
};
